export type ComparisonRow = {
  topic: string
  template: string
  custom: string
}

export const comparisonRows: ComparisonRow[] = [
  {
    topic: 'Where it starts',
    template: 'A theme built for someone else, bent until it almost fits your business.',
    custom: 'We map how you actually operate, then build the structure that fits it.',
  },
  {
    topic: 'Ecommerce cost',
    template: 'Transaction fees plus monthly add-ons for things that should be standard.',
    custom: '0% transaction fees from WebsiteForge, with a checkout we control.',
  },
  {
    topic: 'Making changes',
    template: 'Edits break the layout, so the site quietly stops getting updated.',
    custom: 'A CMS scoped to your content, plus training — or send it to us.',
  },
  {
    topic: 'SEO structure',
    template: 'Bloated markup, slow pages, and no service or location architecture.',
    custom: 'Clean structure, fast pages, and a plan measured against leads.',
  },
  {
    topic: 'Custom functionality',
    template: 'Only what a plugin marketplace happens to offer this year.',
    custom: 'API workflows into your CRM, accounting, scheduling, or inventory.',
  },
  {
    topic: 'Growing into it',
    template: 'You hit the ceiling of the builder and start over from scratch.',
    custom: 'A modular build that extends as you add services and channels.',
  },
  {
    topic: 'Who you reach',
    template: 'A help centre, a chatbot, and a queue in another time zone.',
    custom: 'Our team by phone, email, or ticket — people who built your site.',
  },
]
